import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { DESTINATIONS } from "@/lib/siteData";
import { usePageMeta } from "@/lib/seo";

const REGIONS = ["All", "Africa", "Asia", "Middle East", "Europe", "Indian Ocean"];

export default function Destinations() {
  usePageMeta("Destinations", "Explore top destinations with Makchester Tours & Travel — Dubai, Zanzibar, Cape Town, Victoria Falls, Thailand, Mauritius and more.");
  const [region, setRegion] = useState("All");
  const list = DESTINATIONS.filter((d) => region === "All" || d.region.includes(region));
  return (
    <div>
      <section className="relative py-28 bg-[#0A2E4D] overflow-hidden">
        <img src="https://images.unsplash.com/photo-1488646953014-85cb44e25828?q=80&w=1920&auto=format&fit=crop" alt="World travel" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="mk-gold-line mb-6 inline-block" />
          <p className="text-xs uppercase tracking-[0.25em] text-[#E3BA45] font-bold mb-3">Destinations</p>
          <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-white">The world, curated for you</h1>
          <p className="text-slate-300 mt-5 max-w-xl mx-auto">45+ countries served. Flights, visas, hotels and experiences — all arranged by one consultant.</p>
        </div>
      </section>

      <section className="py-20 lg:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-2 mb-14">
            {REGIONS.map((r) => (
              <button key={r} onClick={() => setRegion(r)} data-testid={`region-filter-${r.toLowerCase().replace(/\s+/g, "-")}`}
                className={`px-5 py-2 rounded-full text-sm font-semibold transition-colors ${region === r ? "bg-[#0A2E4D] text-white" : "bg-[#F3F4F6] text-[#4B5563] hover:bg-[#E5E7EB]"}`}>{r}</button>
            ))}
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {list.map((d) => (
              <div key={d.name} className="mk-card overflow-hidden group" data-testid={`destinations-page-card-${d.name.toLowerCase().replace(/\s+/g, "-")}`}>
                <div className="relative h-64 overflow-hidden">
                  <img src={d.image} alt={d.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <div className="absolute top-4 right-4 bg-[#0A2E4D]/85 backdrop-blur text-white rounded-full px-3.5 py-1.5 text-xs font-semibold">from ${d.price}</div>
                </div>
                <div className="p-7">
                  <div className="text-[11px] uppercase tracking-[0.2em] text-[#D4A62A] font-bold">{d.region}</div>
                  <h3 className="font-serif-display text-2xl text-[#0A2E4D] mt-1">{d.name}</h3>
                  <p className="text-sm text-[#4B5563] mt-2.5 leading-relaxed">{d.desc}</p>
                  <Link to={`/holidays/request?destination=${encodeURIComponent(d.name)}`} className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[#0A2E4D] border-b-2 border-[#D4A62A] pb-1 hover:gap-3 transition-all">Explore {d.name} <ArrowRight size={14} /></Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
